import { authAxios } from "services";

// eslint-disable-next-line import/prefer-default-export
export const fetchAll = (page) => authAxios().get(`/vehicleRequests?page=${page}`);
